import axios from 'axios';
import { type StrapiApiErrorResponse, isStrapiApiErrorResponse } from './isStrapiApiErrorResponse';

export const getErrorMessage = (error: Error): string =>
  axios.isAxiosError(error) && isStrapiApiErrorResponse(error.response?.data)
    ? error.response.data.error.message
    : error.message;

export const getErrorDetails = (error: Error): StrapiApiErrorResponse['error']['details'] | undefined => {
  if (axios.isAxiosError(error) && isStrapiApiErrorResponse(error.response?.data)) {
    const { details } = error.response.data.error;

    if (details && Array.isArray(details)) {
      return details;
    }
  }

  return undefined;
};
